<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-1 mr-4">404</h1>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The page you are looking for was not found.</p>
            <p class="text-muted">Please return to our <a href="dashboard">Homepage</a></p>
            <p class="text-muted"><i class="fa fa-phone"></i><a href="tel:021-31900658"> 021-31900658</a> | <i class="fa fa-envelope-square"></i> <a href="mailto:support@treasury.id"> support@treasury.id</a></p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
